import { useCallback, useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { getTimeOffRequest } from '../application/get-time-off-request'
import { activeTimeOffRequest$ } from '../store'
import { timeoff, notify } from '../wiring'

const useTimeOffRequest = (id: string | null) => {
	const request = useSelector(activeTimeOffRequest$)

	const reload = useCallback(async () => {
		if (!id) {
			activeTimeOffRequest$.set(null)
			return
		}
		const result = await getTimeOffRequest(timeoff, id, notify)
		activeTimeOffRequest$.set(result)
	}, [id])

	useEffect(() => {
		reload()
	}, [reload])

	return { request, reload }
}

export { useTimeOffRequest }
